import { createRedirectToContactUs } from '../../PatientRecord/utils/patientRecordUtils';

const getDeceasedConfig = (labels, country, lang) => {
  const redirectToContactUs = createRedirectToContactUs(
    country,
    lang,
  );

  return {
    errorView: {
      layout: 'horizontal',
      imgAlt: 'labels.assignLoaner.deceased.errorMessage.imgAlt',
      imgSrc:
        'https://mss-p-007-delivery.stylelabs.cloud/api/public/content/CDS_Pictogram_Password?v=e6c2d773',
      imgWidth: '116',
      title: 'labels.assignLoaner.deceased.errorMessage.title',
      text: 'labels.assignLoaner.deceased.errorMessage.text',
      buttons: [
        {
          name: 'dpxContactUs',
          variant: 'brand-primary',
          text: labels[
            'labels.assignLoaner.deceased.errorMessage.button'
          ],
          icon: '',
          link: '',
          action: 'link-dpx-login',
          useCallback: true,
        },
      ],
      handleCallback: redirectToContactUs,
    },
    labels,
  };
};

const getPatientTableConfig = ({ handleAssignLoaner }) => {
  return {
    columns: [
      {
        display: 'labels.assignLoaner.dataTable.columns.header.name',
        field: 'name',
        format: {
          type: 'link',
          onClick: handleAssignLoaner,
        },
        hiddenColumnView: 'mobile',
        sortable: false,
      },
      {
        display:
          'labels.assignLoaner.dataTable.columns.header.cochlearId',
        field: 'cochlearId',
        format: {
          type: 'string',
          onClick: null,
        },
        hiddenColumnView: 'mobile',
        sortable: false,
      },
      {
        display: 'labels.assignLoaner.dataTable.columns.header.dob',
        field: 'dob',
        format: {
          type: 'string',
          onClick: null,
        },
        hiddenColumnView: 'mobile',
        sortable: false,
      },
      {
        display:
          'labels.assignLoaner.dataTable.columns.header.address',
        field: 'address',
        format: {
          type: 'string',
          onClick: null,
        },
        hiddenColumnView: 'mobile',
        sortable: false,
      },
    ],
    country: 'US',
    language: 'en',
    formats: {
      date: 'yyyy-mm-dd',
      currency: 'USD',
    },
    labels: {
      rowLoading: 'labels.assignLoaner.dataTable.view.loading',
    },
    hasCollapseContent: true,
    highlight: false,
    hover: true,
    hiddenColumnLabel: true,
    restrictWidth: true,
    sortable: false,
    loadingText: 'labels.common.loadingText',
    resultsHeadingFormat:
      'labels.assignLoaner.dataTable.resultsHeadingFormat',
    resultsLimit: {
      maxResults: 100,
      content: 'labels.assignLoaner.dataTable.resultsLimit.content',
      additional: {
        textOrder:
          'labels.assignLoaner.dataTable.resultsLimit.additional.textOrder',
        text1:
          'labels.assignLoaner.dataTable.resultsLimit.additional.text1',
        text2:
          'labels.assignLoaner.dataTable.resultsLimit.additional.text2',
        linkText1:
          'labels.assignLoaner.dataTable.resultsLimit.additional.linkText1',
        function1: () => {},
      },
      pictogramSrc:
        'https://mss-p-007-delivery.stylelabs.cloud/api/public/content/66c25eb795cd471a8e7e1dc06c32408a?v=1ccadacd',
    },
    noSearchResults: {
      format: 'labels.assignLoaner.dataTable.noSearchResults.format',
      content:
        'labels.assignLoaner.dataTable.noSearchResults.content',
      pictogramSrc:
        'https://mss-p-007-delivery.stylelabs.cloud/api/public/content/66c25eb795cd471a8e7e1dc06c32408a?v=1ccadacd',
      additional: {
        function1: () => {},
        function2: () => {},
        linkText1:
          'labels.assignLoaner.dataTable.noSearchResults.additional.linkText1',
        linkText2:
          'labels.assignLoaner.dataTable.noSearchResults.additional.linkText2',
        text1:
          'labels.assignLoaner.dataTable.noSearchResults.additional.text1',
        text2:
          'labels.assignLoaner.dataTable.noSearchResults.additional.text2',
        textOrder:
          'labels.assignLoaner.dataTable.noSearchResults.additional.textOrder',
      },
    },
    lazyLoadOptions: {
      pageSize: 25,
      loadMoreText:
        'labels.assignLoaner.lazyLoadOptions.loadMoreText',
    },
    handleSortDataChange: () => {},
  };
};

export { getPatientTableConfig, getDeceasedConfig };
